export default __webpack_public_path__ + "static/media/Trading window closure intimation.83d514a7.pdf";